import Vue from 'vue'
import Vuex from 'vuex'
import basket from './basket';
import voucher from './voucher';
import address from './address';
import recipes from './recipes';
import shopify from './shopify';
import profile from './profile';
import configuration from './config';
import ui from './ui';
import storyblok from './storyblok';
import analytics from './analytics';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    basket,
    voucher,
    address,
    recipes,
    shopify,
    configuration,
    ui,
    storyblok,
    profile,
    analytics
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
})